<template>
  <div class="card">
    <div class="list list--nested">
      <div class="list__header py-2 pr-2 pl-6 flex justify-between items-baseline">
        <div class="text-gray-700 capitalize">
          {{ $te('costEstimate') ? $t('costEstimate') : 'cost estimate' }}
        </div>
      </div>
      <div class="list__body">
        <div v-if="campaign.fixedCost" class="list__item p-6 space-y-2">
          <span class="text-sm text-gray-700 capitalize">
            {{ $te('cost') ? $t('cost') : 'cost' }}
          </span>
          <div v-if="campaign.minCost">
            {{ campaign.minCost | float }} &euro; ({{ minPercentProfit }}%)
          </div>
          <div v-else>
            {{ $te('notSet') ? $t('notSet') : 'not set' }}
          </div>
        </div>
        <div v-else class="list__item p-6 space-y-2">
          <span class="text-sm text-gray-700 capitalize">
            {{ $te('cost') ? $t('cost') : 'cost' }}
          </span>
          <div v-if="campaign.minCost && campaign.maxCost">
            <p>
              {{ $te('minimum') ? $t('minimum') : 'minimum' }}:
              {{ campaign.minCost | float }} &euro; ({{ minPercentProfit }}%)
            </p>
            <p>
              {{ $te('maximum') ? $t('maximum') : 'maximum' }}:
              {{ campaign.maxCost | float }} &euro; ({{ maxPercentProfit }}%)
            </p>
          </div>
          <h6 v-else>
            {{ $te('notSet') ? $t('notSet') : 'not set' }}
          </h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CampaignTargetingAndPricing',
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
  computed: {
    minPercentProfit() {
      const { pricePerResult, minCost } = this.campaign;
      if (!pricePerResult || !minCost) return 0;
      return (100 * ((pricePerResult - minCost) / pricePerResult)).toFixed(2);
    },
    maxPercentProfit() {
      const { pricePerResult, maxCost } = this.campaign;
      if (!pricePerResult || !maxCost) return 0;
      return (100 * ((pricePerResult - maxCost) / pricePerResult)).toFixed(2);
    },
  },
};
</script>
